<template>
 <div>
    <Header />
    <div class="inner-wrapper">
      <Subscriptions />
    </div>
  </div>
</template>

<script>
  import Subscriptions from '../components/Subscriptions.vue';
  import Header from '../components/Header.vue';

  export default {
    name : 'default',
    data : function() {
      return {
      }
    },
    components : {
      Subscriptions, Header 
    }
  };
</script>